module.exports = __webpack_public_path__ + "img/index-t-slide4.4f59e991.png";